module.exports = __webpack_public_path__ + "static/media/sardinia.e7773363.svg";